import { render, staticRenderFns } from "./BookingStaffSetting.vue?vue&type=template&id=4528adc2"
import script from "./BookingStaffSetting.vue?vue&type=script&lang=js"
export * from "./BookingStaffSetting.vue?vue&type=script&lang=js"
import style0 from "./BookingStaffSetting.vue?vue&type=style&index=0&id=4528adc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports